<script>
  export let step;
  export let label;
  export let value = '';
  export let link ='';

  import { navigate } from 'svelte-routing';
</script>

<style>
  .row {
    padding: 4px 8px;
  }
  .light {
    width: 17px;
    height: 17px;
    border-radius: 8px;
    border: 1px solid #aaa;
    background-color: #ccc;
    display: inline-block;
    vertical-align: middle;
    margin-top: -2px;
  }
  .text {
    display: inline-block;
    vertical-align: middle;
    height: 25px;
  }
  .name {
    width: 80px;
    white-space: nowrap;
  }
  .value {
    font-weight: bold;
  }
  .green {
    background-color: green;
  }
  .is-active {
    background-color: cornflowerblue;
  }
  .is-clickable {
    cursor: pointer;
  }
</style>

<div class="row" class:is-active={step == 0} class:is-clickable={step < 0} on:click={() => step > 0 && navigate(link)}>
  <div class="light {step <= 0 ? 'grey' : 'green'}"/>
  <div class="text name">{label}</div>
  <div class="text value">{value}</div>
</div>
